import { Table, TableRow, Typography } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'
import React from 'react'

import { SANCTIONS_TABLE_HEADER, SANCTIONS_TABLE_LABEL } from '../HistoricalSanctionsList.constants'
import { TableCell, TableContainer } from '../HistoricalSanctionsList.styles'

/**
 * The accessible table shell with the shared header row.
 */
const SanctionsTable = ({ children }) => (
  <TableContainer>
    <Table accessibility={{ label: SANCTIONS_TABLE_LABEL }} enableStripped>
      <TableRow enableHead>
        {SANCTIONS_TABLE_HEADER.map(({ key, label, width }) => (
          <TableCell key={key} padding="8px 16px" width={width}>
            <Typography fontWeight="bold" variant="caption">
              {label}
            </Typography>
          </TableCell>
        ))}
      </TableRow>

      {children}
    </Table>
  </TableContainer>
)

SanctionsTable.propTypes = {
  children: PropTypes.node
}

export default SanctionsTable
